module.exports = __webpack_public_path__ + "img/template_1.1cd612c0.png";